import { useRef } from "react";
import useGlobalSettingColumnDefs from "./useGlobalSettingColumnDefs";
import AgGrid from "../../../UI/AgGrid";

type Props = {
  onEditHandler: (id?: number) => void;
  onDeleteHandler: (id?: number) => void;
  data: any[];
};

const GlobalSettingTable = ({
  onEditHandler,
  onDeleteHandler,
  data,
}: Props) => {
  const gridRef = useRef(null);
  const columnDefs = useGlobalSettingColumnDefs(onEditHandler, onDeleteHandler);

  return (
    <AgGrid
      columnDefs={columnDefs}
      ref={gridRef}
      rowData={data || []}
      height={650}
      disabledSidebar
    />
  );
};

export default GlobalSettingTable;
